export const tips = [
  {
    id: "1",
    title: "凌晨四点的社区食堂，给环卫工留了一扇门",
    summary:
      "我们小区门口的便民食堂最近改了营业时间，凌晨四点就开灯，老板说是专门给早班环卫工和夜班司机留的。",
    category: "city",
    author: "夜行的猫",
    createdAt: "2026-09-08 06:12",
    location: "老城区 · 幸福里社区",
    views: 18420,
    likes: 1263,
    status: "hot",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20a%20small%20neighborhood%20community%20canteen%20at%20dawn%20with%20steaming%20food%20counter%20and%20plastic%20stools%2C%20candid%20documentary%20style%2C%20soft%20warm%20natural%20light%2C%20muted%20amber%20terracotta%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-01&orientation=landscape",
    content: [
      "事情是从上个月开始的。我因为倒夜班，经常凌晨四五点才回家，路过小区门口那家便民食堂的时候发现灯已经亮了，里面坐着几个穿反光背心的环卫工，安安静静地在吃面。",
      "我问过老板，他说以前是六点半开门，后来发现凌晨扫街的师傅们没地方吃口热的，就把开门时间提前到了四点，价目表上还单独写了一栏早班价，一碗阳春面三块钱。",
      "最让我意外的是门口那扇小门，本来晚上是锁着的，现在老板把它留了条缝，说天气越来越凉，让大家不用在外面等。门框上贴了张手写的纸，毛笔字，写着早班热汤已备好。",
      "我在那儿坐了两个早上，陆陆续续来了七八个人，有环卫工，也有跑夜班的网约车司机。大家说话都压着音量，像怕打扰谁。这种安静的默契，是我在这个城市住了六年第一次见到。",
    ],
    tags: ["社区", "民生", "小店"],
  },
  {
    id: "2",
    title: "菜市场的价签背面，藏着一行小字",
    summary:
      "连续三周，同一家菜摊的价签背面都用铅笔写着当天的进货价，老板说这是给老顾客看的，省得大家砍价。",
    category: "consumer",
    author: "买菜的陈",
    createdAt: "2026-09-07 18:40",
    location: "城南 · 朝阳农贸市场",
    views: 9860,
    likes: 742,
    status: "verified",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20fresh%20vegetables%20with%20handwritten%20paper%20price%20tags%20in%20a%20traditional%20market%20stall%2C%20candid%20documentary%20style%2C%20soft%20warm%20natural%20light%2C%20muted%20amber%20terracotta%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-02&orientation=landscape",
    content: [
      "第一次注意到是因为我砍价砍得太狠，老板娘没生气，反而把价签翻过来给我看，背面用铅笔写着一个数字。她说这是今天早上批发价。",
      "我后来连续三周都去这家买，发现她每天都写。涨价的时候会提前说明，比如今天黄瓜进价贵了两毛，售价也就跟着调了两毛。降价同理。",
      "摊位上其他几个老板都知道这件事，有的觉得多此一举，有的也开始跟着写。现在整排菜摊翻价签成了习惯动作，反倒成了这个市场的一个小特色。",
      "我写这条不是想夸谁，只是觉得明明白白做生意这件事，其实没那么难，只是需要有人先开个头。",
    ],
    tags: ["消费", "菜市场", "明码标价"],
  },
  {
    id: "3",
    title: "写字楼负一层的深夜班车，司机记了三年名册",
    summary:
      "我们写字楼的通勤班车司机有本手写名册，记录了三年里每晚最后一班谁没上车，好提醒还在加班的人。",
    category: "workplace",
    author: "加班第七年",
    createdAt: "2026-09-07 23:15",
    location: "高新区 · 云谷大厦",
    views: 15230,
    likes: 1104,
    status: "hot",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20a%20city%20shuttle%20bus%20interior%20at%20night%20with%20warm%20ceiling%20lights%20and%20empty%20seats%2C%20candid%20documentary%20style%2C%20soft%20warm%20light%2C%20muted%20amber%20terracotta%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-03&orientation=landscape",
    content: [
      "班车是晚上十一点发最后一趟。司机姓吴，五十多岁，车上扶手旁边挂着一个有点旧的硬皮本子，一开始我以为是行车记录。",
      "有一次我赶末班车，上车的时候他抬头问我，是不是 18 楼那家做设计的。我说是。他翻了翻本子说，你们组这周有三天是最后一班才下来的，我记得住。",
      "后来我才知道，那本子上记的是每晚没赶上车的人的名字或者工位，第二天早上他会跟物业打个招呼，让人留一份早餐。三年了，本子换了四本。",
      "吴师傅说，他没什么本事，就知道深夜里还在亮着的楼层，里面的人都挺不容易的。",
    ],
    tags: ["职场", "通勤", "加班"],
  },
  {
    id: "4",
    title: "大学自习室里的共享纸条墙，越贴越厚",
    summary:
      "图书馆三楼靠窗的位置，有人开始贴便利贴，从找座位的提醒，变成了陌生人之间的留言墙。",
    category: "campus",
    author: "图书馆常客",
    createdAt: "2026-09-06 20:05",
    location: "城东 · 明德大学",
    views: 7620,
    likes: 588,
    status: "new",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20colorful%20sticky%20notes%20on%20a%20library%20window%20with%20handwritten%20messages%20and%20afternoon%20sunlight%2C%20candid%20documentary%20style%2C%20soft%20warm%20light%2C%20muted%20amber%20terracotta%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-04&orientation=landscape",
    content: [
      "最开始只是有人贴了张纸条，写着这个位置明天八点前有人，麻烦别占。后来越贴越多，一个月不到，整块玻璃都贴满了。",
      "我花了一下午把上面的内容看了一遍。有找研友的，有推荐复习资料的，有提醒对面桌同学耳机漏音的，还有一张写着别熬夜，你脸色不太好。",
      "图书馆管理员没有撕掉它们，反而在旁边的墙上贴了一张空白的大纸，说喜欢写就写在这边，玻璃留给采光。",
      "那天我走的时候，看到有人在那张大纸上写了一句：谢谢三楼靠窗的每一个人。字不算好看，但很认真。",
    ],
    tags: ["校园", "图书馆", "陌生人"],
  },
  {
    id: "5",
    title: "老城区最后一位修钢笔的师傅",
    summary:
      "巷子深处的修钢笔铺子只开半天，师傅说现在来修笔的多是学生和写字的老人，一个月不到二十单。",
    category: "life",
    author: "巷口散步",
    createdAt: "2026-09-06 09:32",
    location: "老城区 · 竹竿巷",
    views: 11340,
    likes: 906,
    status: "verified",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20a%20small%20old%20workshop%20desk%20with%20fountain%20pen%20repair%20tools%20and%20magnifier%2C%20candid%20documentary%20style%2C%20soft%20warm%20window%20light%2C%20muted%20amber%20terracotta%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-05&orientation=landscape",
    content: [
      "铺子没有招牌，只有门口挂了块木板，上面用墨写了三个字：修笔处。师傅姓沈，七十岁，早上八点到中午十二点营业，下午要接孙子放学。",
      "他说这些年修的东西变了。以前多是企业文员的一整盒办公笔，现在多是学生带来的一两支，还有几位一直用钢笔写字的老先生，每个月都会来调一次笔尖。",
      "最好玩的是他的抽屉，按型号分了十几个格子，最老的一格是上世纪八十年代的笔尖，他说有些型号已经停产了，剩下的用一只少一只。",
      "我问他会不会关门。他想了想说，等哪天连找上门的人都没有了，再说吧。现在一个月还有十几单，够本了。",
    ],
    tags: ["手艺人", "老城", "钢笔"],
  },
  {
    id: "6",
    title: "公园里免费的露天电影，幕布是投影打的",
    summary:
      "每周五晚上，城西公园的空地上会放一场露天电影，组织者是位退休教师，自带投影和折叠凳。",
    category: "trend",
    author: "带娃的爸爸",
    createdAt: "2026-09-05 21:48",
    location: "城西 · 桂香公园",
    views: 21460,
    likes: 1720,
    status: "hot",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20an%20outdoor%20night%20movie%20screen%20in%20a%20park%20with%20families%20sitting%20on%20folding%20stools%2C%20candid%20documentary%20style%2C%20soft%20warm%20ambient%20light%2C%20muted%20amber%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-06&orientation=landscape",
    content: [
      "第一次去是被孩子拉着，本以为是商家的活动，到了才发现是位退休教师自己张罗的。投影机、幕布、插线板，全都装在一个旧行李箱里。",
      "片单是大家投票选的，动作片、老电影、动画轮着来。老人说版权方面只放已经进入公共领域或者有授权的片子，自己不敢乱来。",
      "现场最动人的一幕是散场，没有人留下垃圾，几个原本互不认识的家长会自发把折叠凳收好摞起来。老人只是站在旁边，一个个说谢谢。",
      "已经连着放了两个月，下雨就顺延。上周五来了差不多两百人，是我见过公园里最热闹的一次。",
    ],
    tags: ["公园", "露天电影", "邻里"],
  },
  {
    id: "7",
    title: "便利店里的临期折扣区，下午五点后才出现",
    summary:
      "我们楼下便利店在货架最里面设了一个折扣区，只在下午五点后开放，价签是店员手写的，很多人还不知道。",
    category: "consumer",
    author: "楼下常客",
    createdAt: "2026-09-05 17:20",
    location: "市中区 · 银杏路",
    views: 6480,
    likes: 412,
    status: "new",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20a%20convenience%20store%20shelf%20corner%20with%20handwritten%20discount%20labels%20and%20small%20boxes%2C%20candid%20documentary%20style%2C%20soft%20warm%20fluorescent%20light%2C%20muted%20amber%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-07&orientation=landscape",
    content: [
      "这个折扣区藏得挺深，在饮料冷柜和仓库门之间的夹缝里，招牌是店员用马克笔写的几个字，字体歪歪扭扭，但写得很清楚。",
      "规则是这样的：临近保质期但仍在安全范围内的三明治、饭团、面包，下午五点后统一放到这个区域，价格贴在原有价签下面，普遍对折。",
      "我特意问过店员，是不是卖不掉才放出来。她说不是，是为了减少浪费，每天傍晚固定整理，快过期的第二天早上就报损了，不会混在里面。",
      "知道的人确实不多。我连着去了两周，五点零五分到的时候那一片基本都是满的。分享出来，希望需要的人能少花点钱。",
    ],
    tags: ["便利店", "折扣", "省钱"],
  },
  {
    id: "8",
    title: "地铁口的共享雨伞，三个月没丢一把",
    summary:
      "地铁三号口放了二十把共享雨伞，扫码即取，三个月后盘点，一把没少，反而多了三把。",
    category: "city",
    author: "通勤的小李",
    createdAt: "2026-09-04 08:05",
    location: "地铁 · 三号出入口",
    views: 8290,
    likes: 655,
    status: "verified",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20a%20shared%20umbrella%20rack%20near%20a%20subway%20entrance%20with%20yellow%20umbrellas%20on%20a%20rainy%20day%2C%20candid%20documentary%20style%2C%20soft%20warm%20light%2C%20muted%20amber%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-08&orientation=landscape",
    content: [
      "雨伞架是社区志愿者用旧自行车架改的，上面贴了张二维码，扫一下登记手机号后四位就能取，用完放回任意一个点都行。",
      "最开始大家都不看好，觉得肯定丢。结果三个月盘点，二十把变成了二十三把。多出来的三把是有人自己买的新伞，放进来一起共享。",
      "负责维护的志愿者说，唯一的问题是雨天取的人多，有时候会不够用，他准备再添十把，预算靠社区里几个人凑。",
      "我不是这个社区的人，只是每天在这换乘。但看到伞架上那行手写的用完请放回，突然觉得城市也没那么冷。",
    ],
    tags: ["地铁", "共享", "雨天"],
  },
  {
    id: "9",
    title: "公司楼下悄悄开张的宠物托管，只接半天单",
    summary:
      "写字楼一层多了家宠物托管店，只在工作日白天营业，专门接附近上班族的猫狗，按半天计费。",
    category: "workplace",
    author: "养猫的打工人",
    createdAt: "2026-09-03 13:40",
    location: "高新区 · 云谷大厦",
    views: 5320,
    likes: 389,
    status: "new",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20a%20small%20pet%20daycare%20studio%20with%20a%20cat%20resting%20in%20a%20cushioned%20nook%20and%20wooden%20shelves%2C%20candid%20documentary%20style%2C%20soft%20warm%20light%2C%20muted%20amber%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-09&orientation=landscape",
    content: [
      "位置就在大堂旁边原来那间一直空着的铺面，装修非常简单，几张垫子、几个猫爬架，门口没怎么宣传，只贴了一张营业时间。",
      "老板是楼上公司的一位员工，去年被裁之后就没再找正式工作，索性把这块铺面租下来，做起了半天制的宠物托管。",
      "收费不高，半天三十块，比市面上按天算的便宜不少。她说不接长期寄养，只接白天上班没人照看的情况，晚上必须接回家，免得动物不适应。",
      "现在每天固定有五六只，最多的时候十只。她一个人在店里，一边照看一边处理消息，忙，但看起来比上班那会儿轻松。",
    ],
    tags: ["职场", "宠物", "创业"],
  },
  {
    id: "10",
    title: "图书馆里那本被翻烂的绝版书，有人在悄悄修补",
    summary:
      "市图书馆四楼有一本绝版的地方志，书脊都快散了。最近发现有人用棉线和浆糊把它重新装订了一遍。",
    category: "campus",
    author: "查资料的人",
    createdAt: "2026-09-02 15:10",
    location: "市图书馆 · 四楼",
    views: 6180,
    likes: 501,
    status: "verified",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20an%20old%20worn%20hardcover%20book%20being%20rebound%20with%20cotton%20thread%20on%20a%20reading%20desk%2C%20candid%20documentary%20style%2C%20soft%20warm%20light%2C%20muted%20amber%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-10&orientation=landscape",
    content: [
      "我在查一份老资料的时候借到这本书，拿到手发现装订很新，和封面磨损的程度不成比例，管理员说是一个常来的读者修的。",
      "问了才知道，那位读者每周来两次，专门修补四楼工具书里装订松动的部分。他自带针线，用的是那种很细的棉线和可逆的浆糊，说这样以后专业修复还来得及拆。",
      "管理员一开始也犹豫，怕弄坏了担责任。后来请教了市里做古籍修复的老师，确认方法没问题，才同意继续。",
      "那位读者不愿留名字，只说自己退休前在印刷厂干过。他说，书放在这儿没人读没关系，但坏在手里就不合适了。",
    ],
    tags: ["图书馆", "旧书", "修复"],
  },
  {
    id: "11",
    title: "小区团购的团长，把账目贴在电梯里",
    summary:
      "我们小区的团购群换了新团长，第一件事就是把每单的进出价和盈利额贴在电梯间的公告板上。",
    category: "life",
    author: "住三楼的老杨",
    createdAt: "2026-09-01 19:25",
    location: "城北 · 桂苑小区",
    views: 9410,
    likes: 812,
    status: "hot",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20a%20building%20elevator%20notice%20board%20with%20a%20printed%20price%20list%20and%20handwritten%20notes%2C%20candid%20documentary%20style%2C%20soft%20warm%20light%2C%20muted%20amber%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-11&orientation=landscape",
    content: [
      "团购群以前常有争议，主要是价格不透明，有人说团长挣差价挣得多了。新团长上任后没解释，直接把账目打印出来，贴上去了。",
      "一张 A4 纸，左边是进货价，右边是团购价，中间是毛利，一行一个品类，最后汇总一个月总共挣了多少钱，甚至写明了钱花在哪。",
      "公告板旁边放了个小盒子，说如果账目有问题可以直接留言。放了两个月，盒子里只有几张纸，写的都是建议，比如能不能加个海鲜品类。",
      "现在这个团购群是我们楼里最活跃的群之一。上周投票要不要换供应商，参与的人比业主大会还多。",
    ],
    tags: ["团购", "社区", "透明"],
  },
  {
    id: "12",
    title: "城市天台上种菜的人，把收成分给整栋楼",
    summary:
      "我们这栋楼的天台被几户人家改成了菜园，二十多个花箱，收成季节挨家挨户送，从不留名。",
    category: "trend",
    author: "顶楼的邻居",
    createdAt: "2026-08-31 07:50",
    location: "城东 · 望江公寓",
    views: 13670,
    likes: 1042,
    status: "hot",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photograph%20of%20a%20rooftop%20vegetable%20garden%20with%20wooden%20planter%20boxes%20and%20green%20leaves%20in%20soft%20morning%20light%2C%20candid%20documentary%20style%2C%20muted%20amber%20terracotta%20palette%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=baoliao-cover-12&orientation=landscape",
    content: [
      "天台原本堆着杂物，前年物业清理之后就有了空地。最先动手的是六楼一位阿姨，搬了两个花箱上去，种了点小葱和生菜。",
      "第二年就变成了七八户联合，花箱是大家一起凑钱买的，浇水排了班，谁家有空谁上去，钥匙挂在楼道消防栓旁边的小盒子里。",
      "收成的时候最有意思。番茄、小青菜、辣椒，分装成小袋放在每户门口，袋子上只写一句尝尝，不写是谁放的。有心的邻居在楼道贴了张纸回谢，慢慢地那张纸也变成留言板了。",
      "今年天台的番茄收了三百多斤，全楼分完还剩不少，最后拿去送给了隔壁楼的独居老人。楼里的微信群平时很安静，只有这个时候会连着热闹好几天。",
    ],
    tags: ["天台", "种菜", "邻里"],
  },
];